/**
 * 匿名ホットライン開示
 */
export const HOTLINE_DISCLOSE = {
    label: '開示する',
    value: 1,
};
/**
 * 匿名ホットライン非開示
 */
export const HOTLINE_UN_DISCLOSE = {
    label: '開示しない',
    value: 2,
};
/**
 * 匿名ホットライン開示ステータス一覧
 */
export const HOTLINE_DISCLOSES = [HOTLINE_DISCLOSE, HOTLINE_UN_DISCLOSE];
/**
 * 匿名ホットライン開示ステータス値一覧
 */
export const HOTLINE_DISCLOSE_VALUES = HOTLINE_DISCLOSES.map((v) => v.value);
